<div id="app" class="h-100 app"
     [ngClass]="settings.theme"
     [dir]="(settings.rtl) ? 'rtl' : 'ltr'">
  <router-outlet></router-outlet>
</div>
